// PageVariablesSeguradoras.js

export const pageVariables = {
    headers: [
        'NOME', 'CONTATO',  'EMAIL', 'TELEFONE'
    ],
    headerInfo: {
        title: "Seguradoras",
        description: "Esta seção fornece a gestão completa das Seguradoras parceiras cadastradas. O cadastro correto é crítico para que as matrizes de preço e regras de faturamento dos Planos funcionem sem erros sistêmicos."
    },    
    inputs: [
        {
            name: "nome",
            type: "text",
            label: "Nome Fantasia / Nome da Seguradora"
        },
        {
            name: "razao_social",
            type: "text",
            label: "Razão Social"
        },
        {
            name: "cnpj",
            type: "text",
            label: "CNPJ"
        },
        {
            name: "nome_contato",
            type: "text",
            label: "Nome do Contato Principal"
        },
        {
            name: "telefone",
            type: "text",
            label: "Telefone"
        },
        {
            name: "email",
            type: "email",
            label: "E-mail de Contato"
        },
        {
            name: "logo_base64",
            type: "text",
            label: "Logo da Seguradora (Opcional - Base64 ou URL)"
        }
    ],
    page: process.env.VUE_APP_API_URL+"seguradoras",
    seguradorasGetPage: process.env.VUE_APP_API_URL+"getSeguradoras"
};
